import axios from "axios";
import { warehouseActions } from "../../slices/warehouse";
import { workerActions } from "../../slices/workers";

export const getRepoId = "getRepositories";
export const repoDataId = "repositories";

const getRepositories = (data) => {
  const { server, cloner_key, user, mid, controller } = data;
  const id = getRepoId;

  return async (dispatch) => {
    dispatch(workerActions.start(id));
    try {
      const url = server + "api/repositories";
      const response = await axios.get(url, {
        signal: controller.signal,
        headers: { cloner_key },
        params: { id: mid, user },
      });
      const repositories = response.data.repositories;
      dispatch(warehouseActions.load({ id: repoDataId, data: repositories }));
      dispatch(workerActions.finish({ id }));
    } catch (e) {
      if (e.code === "ERR_CANCELED") {
        dispatch(workerActions.clear(id));
        return;
      }
      console.error(e);
      dispatch(workerActions.finish({ id, error: e.message }));
    }
  };
};

export default getRepositories;
